import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="price-combinations"
export default class extends Controller {
  static targets = ['channel', 'category'];
  static values = { options: Array };

  apply() {
    const combination = this.optionsValue.find((entry) => entry.channel === this.channelTarget.value);
    const options = combination ? combination.shooting_category_options : [];
    const previous = this.categoryTarget.value;

    this.categoryTarget.innerHTML = '';
    for (const [label, value] of options) {
      this.categoryTarget.add(new Option(label, value));
    }
    if (options.some(([, value]) => value === previous)) this.categoryTarget.value = previous;
  }
}
